import { ModuleFE_BaseTheme } from '@nu-art/thunderstorm-frontend/index';
export const AppTheme = {
    theme: ['light', 'dark'],
    device: ['desktop', 'tablet', 'mobile']
};
class ModuleFE_Theme_Class extends ModuleFE_BaseTheme {
    constructor() {
        super(AppTheme);
    }
}
export const ModuleFE_Theme = new ModuleFE_Theme_Class();
//# sourceMappingURL=ModuleFE_Theme.js.map